import { BaseFileUploader } from '@/abstracts/base-file-uploader';
import apiService, { type ApiResponse } from '@/services/api.service';
import type { UploadingOptions } from '@/services/types/file-uploader.types';
import type { FileVersion, UploadedFilesDto } from '@/services/types/file.types';

export class FileUploaderV2 extends BaseFileUploader {
  public constructor(version: FileVersion) {
    super(version);
  }

  // Typed as `/files` answers. A route that stores the upload itself, such as a project block's `/image`, answers
  // otherwise, and its caller ignores the answer.
  public async upload(options: UploadingOptions): Promise<ApiResponse<UploadedFilesDto>> {
    const formData = new FormData();
    if (options.data) formData.append('data', JSON.stringify(options.data));
    if (options.files) options.files.forEach((x) => formData.append('files', x));
    if (options.metadata) formData.append('metadata', JSON.stringify(options.metadata));
    return await apiService.post<UploadedFilesDto>(options.url, formData, 'json', {
      'x-file-uploader-version': this._version,
    });
  }
}
